/**
 * XLM - Innovation & Technology | João Rodrigues | v2.0 | 2026*
 * 
 * Modal assíncrono não-bloqueante:
 * - Substitui alert() e confirm() nativos que bloqueiam a UI
 * - Suporte para modos alert (só OK) e confirm (Sim/Não)
 */

import React from 'react'

interface AsyncConfirmProps{
    message:string;
    isAlert?: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}


export function Modal({ message, isAlert, onConfirm, onCancel }: AsyncConfirmProps) {
    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100%', height: '100%',
            backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', 
            alignItems: 'center', justifyContent: 'center', zIndex: 9999
        }}>
            <div className="card p-4 shadow" style={{ minWidth: '300px' }}>
                <p className="mb-4">{message}</p>
                <div className="d-flex justify-content-end gap-2">
                    {!isAlert && (
                        <button className="btn btn-secondary" onClick={onCancel}>
                            Não
                        </button>
                    )}
                    <button className="btn btn-primary" onClick={onConfirm}>
                        {isAlert ? "OK" : "Sim"}
                    </button>
                </div>
            </div>
        </div>
    );
}